// extracted by mini-css-extract-plugin
module.exports = {"alertBox":"AlertBoxPart_alertBox__ywT_V"};